import { Tooltip, Zoom } from "@mui/material";
import axios from "axios";
import Pusher from "pusher-js";
import { useContext, useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import {
    BsBodyText,
    BsBoxArrowInRight,
    BsChatDots,
    BsFillFilePersonFill,
    BsFillPersonLinesFill,
    BsLayoutWtf,
    BsPeople,
    BsPerson,
    BsPostage,
    BsQuestionCircle,
    BsTelephoneOutbound,
    BsChevronLeft,
    BsChevronRight,
} from "react-icons/bs";
import { useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { NavLink, useMatch, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../auth/AuthProvider";
import { iconPath } from "../../constants/constants";
import { useTheme } from "../../context/ThemeContext";
import { PATH_PAGE } from "../../routes/Paths";
import { DashboaredHeader } from "../sharedComponents/DashboaredHeader";
import { LocaleContext } from "./../../config/localization/LanguageProvider";

export const SideBar = ({
    collapse = true,
    setCollapse = () => {},
    onNavItemClick,
}) => {
    const path = iconPath();
    const navigate = useNavigate();
    const { messages } = useIntl();
    const { user, setUser } = useContext(AuthContext);
    const { locale } = useContext(LocaleContext);
    const [count, setCount] = useState(0);
    const [reservationsOpen, setReservationsOpen] = useState(false);
    const queryClient = useQueryClient();
    const { applyTheme } = useTheme();

    // Match hooks for reservations dropdown
    const isIndividualReservMatch = useMatch(PATH_PAGE.reserv);
    const isGroupReservMatch = useMatch(
        PATH_PAGE.groupReserv || "/group-reserv",
    );

    const { themeData } = useTheme();

    useEffect(() => {
        const pusher = new Pusher("87639c06bf9f7a1e1934", {
            cluster: "eu",
        });

        if (!user) {
            console.error("User is not defined.");
            return;
        }

        const fetchInitialUnreadCount = async () => {
            try {
                const token = JSON.parse(
                    localStorage.getItem("user_data"),
                )?.token;

                if (!token) {
                    console.error("User token not found.");
                    return;
                }

                const response = await axios.get(
                    `${process.env.REACT_APP_DOMAIN}/chat-count`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Accept-Language":
                                localStorage.getItem("locale") || "en",
                        },
                    },
                );

                if (response.data && response.data.success) {
                    setCount(response.data.data); // Assuming API response returns the unread message count
                } else {
                    console.error("Invalid response format:", response.data);
                }
            } catch (error) {
                console.error("Error fetching initial unread count:", error);
            }
        };

        fetchInitialUnreadCount();

        const userId = user.data.id;
        const channel = pusher.subscribe(`user${userId}`);

        const handleUnreadMessageCountEvent = (data) => {
            // console.log(data, 'UnreadMessageCountEvent data');
            // if (data.unreadMessagesCount) {
            // fetchInitialU  nreadCount();
            try {
                const token = JSON.parse(
                    localStorage.getItem("user_data"),
                )?.token;

                if (!token) {
                    console.error("User token not found.");
                    return;
                }

                const response = axios
                    .get(`${process.env.REACT_APP_DOMAIN}/chat-count`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then((res) => {
                        setCount(res.data.data);
                    });
            } catch (error) {
                console.error("Error fetching initial unread count:", error);
            }
            // setCount(data.unreadMessagesCount);
            queryClient.setQueryData("getNotifications", (prevData) => {
                const oldData = prevData?.data?.data || prevData;
                const prevNotifications = Array.isArray(oldData?.notifications)
                    ? oldData.notifications
                    : [];
                return {
                    count: (oldData?.count || 0) + 1,
                    notifications: prevNotifications,
                };
            });
            // }
        };

        channel.bind("chatCountEvent", handleUnreadMessageCountEvent);

        return () => {
            channel.unbind("chatCountEvent", handleUnreadMessageCountEvent);
            pusher.disconnect();
        };
    }, [user, queryClient]);

    const handleLogout = () => {
        const userDataString = localStorage.getItem("user_data");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            console.log(userData);
            const authToken = userData?.token.split("|")[1];

            axios
                .post(
                    `${process.env.REACT_APP_DOMAIN}/mentor/v1/auth/logout`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                            "Accept-Language":
                                localStorage.getItem("locale") || "en",
                        },
                    },
                )

                .then((response) => {
                    if (response.status === 200) {
                        localStorage.removeItem("user_data");
                        applyTheme(null);
                        setUser(null);

                        const slug = localStorage.getItem("theme_slug");
                        toast.success(messages["LogOUt"]);
                        navigate(slug ? `/login?slug=${slug}` : `/login`);
                    } else {
                        toast.error(response.data.message);
                    }
                })

                .catch((error) => {
                    toast.error(error?.response?.data?.message);
                });
        }
    };

    return (
        <div className={`sidebar ${!collapse ? "collapsed" : ""}`}>
            <div
                onClick={() => {
                    navigate(PATH_PAGE.clHome);
                    onNavItemClick?.();
                }}
                className={`sidebar-heading ${collapse ? "collapsed" : ""}`}
            >
                {themeData?.logo_url ? (
                    <>
                        <div className="company-logo-wrapper">
                            <img
                                src={themeData?.logo_url}
                                alt="logo"
                                className="company-logo"
                            />
                        </div>
                        <p
                            style={{
                                color: "var(--text-color)",
                                fontSize: "18px",
                                fontWeight: "700",
                                textTransform: "capitalize",
                            }}
                        >
                            {themeData?.company_name}
                        </p>
                    </>
                ) : (
                    <div className="company-logo-wrapper">
                        <img
                            src={`${path}logo.png`}
                            alt="logo"
                            className="website-image"
                        />
                    </div>
                )}
            </div>
            <hr
                className={`mt-3 mb-4 text-primary-dynamic ${!collapse ? "mx-4" : ""}`}
            />
            {user?.data?.photo ||
            user?.data?.first_name ||
            user?.data?.last_name ? (
                <div
                    className={`d-flex align-items-center ${!collapse && (user?.data.first_name || user?.data.last_name) ? "justify-content-start" : "justify-content-center"} gap-2 mb-4 px-4 `}
                >
                    {user?.data?.photo ? (
                        <img
                            src={user?.data?.photo}
                            alt="profile"
                            className="logo-image"
                            style={{ width: "50px", height: "50px" }}
                        />
                    ) : (
                        <div className="rounded-div"></div>
                    )}
                    {!collapse && (
                        <DashboaredHeader
                            text={`${user?.data?.first_name} ${user?.data?.last_name}`}
                            className="text-center mb-0"
                            style={{
                                color: "var(--text-color)",
                                fontSize: "16px",
                            }}
                        />
                    )}
                </div>
            ) : null}

            <Nav
                defaultActiveKey="/home"
                className={`scroller ${
                    collapse
                        ? "align-items-center"
                        : "px-4  justify-content-start"
                }`}
            >
                <div
                    className="w-100 nav-links-container"
                    onClick={(e) => {
                        const el =
                            e.target instanceof Element
                                ? e.target
                                : e.target.parentElement;
                        if (el?.closest?.("a")) {
                            onNavItemClick?.();
                        }
                    }}
                >
                    <Tooltip
                        title={messages["dashboard"]}
                        placement="right"
                        TransitionComponent={Zoom}
                    >
                        <NavLink
                            to={PATH_PAGE.dashboard}
                            className={`nav-link ${
                                useMatch(PATH_PAGE.dashboard)
                                    ? "active-link"
                                    : ""
                            } ${collapse ? "justify-content-center" : ""}`}
                        >
                            <BsLayoutWtf
                                className={`${collapse && "increase-width"}`}
                            />
                            {!collapse && messages["dashboard"]}
                        </NavLink>
                    </Tooltip>
                    <Tooltip
                        title={messages["profile"]}
                        placement="right"
                        TransitionComponent={Zoom}
                    >
                        <NavLink
                            to={PATH_PAGE.profile}
                            className={`nav-link ${
                                useMatch(PATH_PAGE.profile) ? "active-link" : ""
                            } ${collapse ? "justify-content-center" : ""}`}
                        >
                            <BsFillFilePersonFill
                                className={`${collapse && "increase-width"}`}
                            />{" "}
                            {!collapse && messages["profile"]}
                        </NavLink>
                    </Tooltip>
                    <Tooltip
                        title={messages["public_profile"]}
                        placement="right"
                        TransitionComponent={Zoom}
                    >
                        <NavLink
                            to={PATH_PAGE.publicProfile}
                            className={`nav-link ${
                                useMatch(PATH_PAGE.publicProfile)
                                    ? "active-link"
                                    : ""
                            } ${collapse ? "justify-content-center" : ""}`}
                        >
                            <BsFillPersonLinesFill
                                className={`${collapse && "increase-width"}`}
                            />{" "}
                            {!collapse && messages["public_profile"]}
                        </NavLink>
                    </Tooltip>
                    <Tooltip
                        title={messages["reservations"]}
                        placement="right"
                        TransitionComponent={Zoom}
                    >
                        <NavLink
                            to={PATH_PAGE.reserv}
                            className={`nav-link ${
                                useMatch(PATH_PAGE.reserv) ? "active-link" : ""
                            } ${collapse ? "justify-content-center" : ""}`}
                        >
                            <BsTelephoneOutbound
                                className={`${collapse && "increase-width"}`}
                            />{" "}
                            {!collapse && messages["reservations"]}
                        </NavLink>
                        {/* <div
            onClick={(e) => {
              e.preventDefault();
              setReservationsOpen(!reservationsOpen);
            }}
            className={`nav-link ${collapse ? "justify-content-center" : ""}`}
          >
            {!collapse && messages["reservations"]}
          </div> */}
                    </Tooltip>
                    {reservationsOpen && (
                        <div
                            className={`dropdown-menu-custom ${
                                collapse ? "collapsed-dropdown" : ""
                            }`}
                        >
                            <Tooltip
                                title={messages["individual"] || "Individual"}
                                placement="right"
                                TransitionComponent={Zoom}
                            >
                                <NavLink
                                    to={PATH_PAGE.reserv}
                                    className={`nav-link dropdown-item ${
                                        isIndividualReservMatch
                                            ? "active-link"
                                            : ""
                                    } ${collapse ? "justify-content-center" : ""}`}
                                >
                                    <BsPerson
                                        className={`${collapse && "increase-width"}`}
                                    />
                                    {!collapse &&
                                        (messages["individual"] ||
                                            "Individual")}
                                </NavLink>
                            </Tooltip>
                            <Tooltip
                                title={messages["group"] || "Group"}
                                placement="right"
                                TransitionComponent={Zoom}
                            >
                                <NavLink
                                    to={
                                        PATH_PAGE.groupReserv || "/group-reserv"
                                    }
                                    className={`nav-link dropdown-item ${
                                        isGroupReservMatch ? "active-link" : ""
                                    } ${collapse ? "justify-content-center" : ""}`}
                                >
                                    <BsPeople
                                        className={`${collapse && "increase-width"}`}
                                    />
                                    {!collapse &&
                                        (messages["group"] || "Group")}
                                </NavLink>
                            </Tooltip>
                        </div>
                    )}
                    <Tooltip
                        title={messages["packages"]}
                        placement="right"
                        TransitionComponent={Zoom}
                    >
                        <NavLink
                            to={PATH_PAGE.services}
                            className={`nav-link ${
                                useMatch(PATH_PAGE.services)
                                    ? "active-link"
                                    : ""
                            } ${collapse ? "justify-content-center" : ""}`}
                        >
                            <BsPostage
                                className={`${collapse && "increase-width"}`}
                            />
                            {!collapse && messages["packages"]}
                        </NavLink>
                    </Tooltip>
                    <Tooltip
                        title={messages["messages_chat"]}
                        placement="right"
                        TransitionComponent={Zoom}
                    >
                        <NavLink
                            to={PATH_PAGE.chat}
                            className={`nav-link position-relative ${
                                useMatch(PATH_PAGE.chat) ? "active-link" : ""
                            }  ${collapse ? "justify-content-center" : ""}`}
                        >
                            <span className="position-relative d-inline-flex">
                                <BsChatDots
                                    className={`${collapse && "increase-width"}`}
                                />
                                {collapse && count > 0 && (
                                    <span className="chat-badge">{count}</span>
                                )}
                            </span>
                            {!collapse &&
                                messages["messages_chat"] + `(${count})`}
                        </NavLink>
                    </Tooltip>
                    {/* <Tooltip
          title={messages["wallet"]}
          placement="right"
          TransitionComponent={Zoom}
        >
          <NavLink
            to={PATH_PAGE.wallet}
            className={`nav-link ${
              useMatch(PATH_PAGE.wallet) ? "active-link" : ""
            } ${collapse ? "justify-content-center" : ""}`}
          >
            <BsWallet2 className={`${collapse && "increase-width"}`} />{" "}
            {!collapse && messages["wallet"]}
          </NavLink>
        </Tooltip> */}
                    <Tooltip
                        title={messages["privacy_policy"]}
                        placement="right"
                        TransitionComponent={Zoom}
                    >
                        <NavLink
                            to={PATH_PAGE.privacyPolicy}
                            className={`nav-link ${
                                useMatch(PATH_PAGE.privacyPolicy)
                                    ? "active-link"
                                    : ""
                            } ${collapse ? "justify-content-center" : ""}`}
                        >
                            <BsQuestionCircle
                                className={`${collapse && "increase-width"}`}
                            />{" "}
                            {!collapse && messages["privacy_policy"]}
                        </NavLink>
                    </Tooltip>
                    <Tooltip
                        title={messages["FAQ"]}
                        placement="right"
                        TransitionComponent={Zoom}
                    >
                        <NavLink
                            to={PATH_PAGE.faq}
                            className={`nav-link ${
                                useMatch(PATH_PAGE.faq) ? "active-link" : ""
                            } ${collapse ? "justify-content-center" : ""}`}
                        >
                            <BsBodyText
                                className={`${collapse && "increase-width"}`}
                            />{" "}
                            {!collapse && messages["FAQ"]}
                        </NavLink>
                    </Tooltip>
                </div>
                <Tooltip
                    title={messages["logout"]}
                    placement="right"
                    TransitionComponent={Zoom}
                >
                    <p
                        onClick={() => {
                            onNavItemClick?.();
                            handleLogout();
                        }}
                        className={`nav-link nav-logout ${
                            collapse
                                ? "justify-content-center increase-width"
                                : ""
                        }`}
                    >
                        <BsBoxArrowInRight
                            className={`${collapse && "increase-width"}`}
                        />{" "}
                        {!collapse && messages["logout"]}
                    </p>
                </Tooltip>
                {/* Add more NavLink items with icons as needed */}
            </Nav>

            {/* Toggle Button */}
            <div
                className="toggle-btn"
                onClick={() => setCollapse(!collapse)}
            >
                                {collapse ? <BsChevronRight /> : <BsChevronLeft />}
                {/* {collapse ? <BsChevronLeft /> : <BsChevronRight />} */}
            </div>
        </div>
    );
};
